//////////////////////////////////////////////////////////////////////
// Configuration for awards granted by Toastably to a provider.     //
//////////////////////////////////////////////////////////////////////

/**
 * Awards are stored on the provider, not the listing:
 * user.attributes.profile.publicData.awards = ['first100'].
 * One provider, many listings, one award, inherited by all of them.
 *
 * Awards and badges are different axes. ANY award produces the single 'awarded'
 * badge on a card; the listing page names the specific award instead. Adding a
 * second award must not add a second badge.
 *
 * ARRAY POSITION IS PRIORITY when a provider holds more than one.
 */
export const awards = [
  {
    slug: 'first100',
    labelKey: 'Award.first100',
  },
];
